import { IMDSCalendarGridBodyProps } from "./calendar-grid-body.types";
import { StyledCalendarGridBody } from "./calendar-grid-body.style";

export function MDSCalendarGridBody(props: IMDSCalendarGridBodyProps) {
  return <StyledCalendarGridBody {...props} />;
}
